/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ProfilesArchivePathParams, ProfilesArchiveResponse } from '../types/ProfilesArchive'

/**
 * DELETE /:organisation/profiles/:profile
 * @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::archive
 */
export async function profilesArchive(
	organisation: ProfilesArchivePathParams['organisation'],
	profile: ProfilesArchivePathParams['profile'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ProfilesArchiveResponse>> {
	return axiosInstance.delete(`/${organisation}/profiles/${profile}`, config)
}
